export const ERROR_TYPES = {
  UNABLE_TO_PARSE_USER_REQUEST_PARAMS: 'custom-error/unable-to-parse-user-request-params',
  INVALID_SESSION_OBJECT: 'custom-error/invalis-session-object',
  INVALID_TOKEN_FORMAT: 'custom-error/invalid-token-format',
  INVALID_TOKEN: 'custom-error/invalid-token',
  TOKEN_EXPIRED: 'custom-error/token-expired',
  INVALID_VISITOR_TOKEN: 'custom-error/invalid-visitor-token',
  UNAUTHORIZED_CONNECT_WITH_NO_VISITOR_TOKEN: 'custom-error/unauthorized-connect-with-no-visitor-token'
};

export function CustomError ({ type, message = null, metaInfo = null, ...payload }) {
  return {
    type,
    message: message || type,
    metaInfo,
    payload
  };
};
